/**
 * MaskInfo Component Types and Constants
 */

// Attribute names
export const ATTRIBUTES = {
  MASK_VALUE: 'mask-value',
  EXPOSE_VALUE: 'expose-value',
} as const

// Event names
export const EVENTS = {
  MASK_VALUE: 'mask-value',
  EXPOSE_VALUE: 'expose-value',
} as const

// Action types for event details
export const ACTION_TYPES = {
  MASK_VALUE: 'mask-value',
  EXPOSE_VALUE: 'expose-value',
} as const

// Element selectors (for internal DOM queries)
export const SELECTORS = {
  SPAN: 'span',
  ICON: 'wa-icon',
  BUTTON: 'wa-button',
} as const

// Event detail interfaces
export interface MaskInfoEventDetail {
  actionType: (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES]
}

export type AttributeName = (typeof ATTRIBUTES)[keyof typeof ATTRIBUTES]
export type EventName = (typeof EVENTS)[keyof typeof EVENTS]
export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES]
